import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import {HttpStatusCodes} from '../../../util/uiconstants';

export default function executiveDashboardReducer(state = initialstate.executiveDashboard, action) {
	switch (action.type) {
		case types.SET_DASHBOARD_COMMON_STATE: {
			let tempState = {...state, ...action.data};
			return tempState;
		}
		case types.AUTO_ASSIGN_PIC_EQR_TASK: {
			let tempState = _.cloneDeep(state);
			tempState = {...tempState, ...action.autoAssignObj}
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				tempState = {...tempState, ...action.autoAssignObj, assignedCount: action.response.taskUpdatedCount};
				return tempState;
			}
			return tempState;
		}
		default:
			return state;
	}
}
